// extracted by mini-css-extract-plugin
export default {"btnClose":"CloseBtn_btnClose__kYkfT"};